module.exports = __webpack_public_path__ + "static/media/green-close-ic.dd551ad4.svg";